import { deriveDbDateFromName } from "./dbDate.js";

export function normalizeDbDateString(v){
      const s = String(v || "").trim();
      if (!s) return "";
      // YYYY[-_.]MM[-_.]DD
      let m = s.match(/((?:19|20)\d{2})[-_.](0[1-9]|1[0-2])[-_.](0[1-9]|[12]\d|3[01])/);
      if (m) return `${m[1]}-${m[2]}-${m[3]}`;
      // YYYYMMDD
      m = s.match(/((?:19|20)\d{2})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])/);
      if (m) return `${m[1]}-${m[2]}-${m[3]}`;
      // DD[-_.]MM[-_.]YYYY
      m = s.match(/(0[1-9]|[12]\d|3[01])[-_.](0[1-9]|1[0-2])[-_.]((?:19|20)\d{2})/);
      if (m) return `${m[3]}-${m[2]}-${m[1]}`;
      return "";
    }

    export function parseTpName(tpName, fallbackSat){
      const raw = String(tpName || "").trim();
      // Example: "[19E-053] SES"
      const m = raw.match(/^\[([^\]-]+)-(\d+)\]\s*(.*)$/);
      if (m){
        return { sat_pos: m[1] || fallbackSat || "", tp_no: m[2] || "", provider: (m[3] || "").trim() };
      }
      return { sat_pos: fallbackSat || "", tp_no: "", provider: raw.replace(/^\[.*?\]\s*/, "").trim() };
    }

    export function getDbDateFromExcel(wb, fileName){
      try{
        const readSheet = (name) => {
          const ws = wb.Sheets && wb.Sheets[name];
          if (!ws) return "";
          const rows = XLSX.utils.sheet_to_json(ws, { defval: "", raw: true });
          if (!rows || rows.length === 0) return "";

          // key/value style: columns "key" + "value"
          const keys0 = Object.keys(rows[0] || {}).map(k => String(k));
          const hasKey = keys0.some(k => k.toLowerCase() === "key") && keys0.some(k => k.toLowerCase() === "value");
          if (hasKey){
            for (const r of rows){
              const k = String(r.key ?? r.Key ?? "").toLowerCase().trim();
              if (!k) continue;
              if (["database_date","db_date","datenbank_date","datenbank_datum","datenbankstand","datenbank_stand","datenbank-stand"].includes(k)){
                const v = r.value ?? r.Value ?? "";
                return normalizeDbDateString(v) || String(v || "").trim();
              }
            }
          }

          // direct column style: Database_Date or db_date in first row
          for (const col of keys0){
            const lc = col.toLowerCase().trim();
            if (["database_date","db_date","datenbankstand","datenbank_stand","datenbank-stand","date"].includes(lc)){
              const v = rows[0][col];
              return normalizeDbDateString(v) || String(v || "").trim();
            }
          }
          return "";
        };

        const fromInfo = readSheet("Info");
        if (fromInfo) return fromInfo;

        const fromMeta = readSheet("_Meta");
        if (fromMeta) return fromMeta;

      } catch (e) {
        console.warn("DB-Date aus Excel konnte nicht gelesen werden:", e);
      }
      // Fallback: Dateiname (oder 'Datum unbekannt' aus deriveDbDateFromName)
      return deriveDbDateFromName(fileName);
    }
